export const ADMIN_LOGIN = `query ($email: String!, $password: String!) {
    admin_login(email: $email, password: $password) {
      message
      token
    }
  }
  `;
